import MobileScreen from "components/MobileScreen"
import { FORM_NAMES } from "constants/index"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Input } from "reactstrap"
import { getFormValues } from "redux-form"
import { DEFAULT_FONT, FONT_TYPES, WIDTH_TYPES } from "./constants"

const getImage = (image = {}) => {
  return image.editedImage || image.originalImage || null
}

const getLogoWidth = (section = {}) => {
  switch (section.widthType) {
    case WIDTH_TYPES.PIXEL:
      return section.widthInPixel + "px"
    case WIDTH_TYPES.PERCENTAGE:
      return section.widthInPercent + "%"
    case WIDTH_TYPES.FULL_WIDTH:
      return "100%"
    default:
      return "auto"
  }
}

const getFontColor = color => {
  return color ? color : "#000"
}

const buttonRenderer = (
  enableOffset = false,
  customLabel,
  fontType = FONT_TYPES.PREDEFINED,
  fontFamily = DEFAULT_FONT,
  fontFile = {},
  fontSize = 12,
  buttonColor = "#44A61B",
  fontColor = "#FFFFFF",
  verticalOffset = 50,
  horizontalOffset = 10,
  buttonText = ""
) => {
  const fontFileUrl = fontFile && (fontFile.dataURI || fontFile.url)
  if (fontType === FONT_TYPES.FILE && fontFileUrl && document) {
    const customFontFamily = new FontFace(
      "customFontFamily",
      `url('${fontFileUrl}')`
    )
    customFontFamily.load().then(loadedFont => {
      document.fonts.add(loadedFont)
    })
  }
  return (
    <div
      style={{
        backgroundColor: buttonColor,
        color: fontColor,
        fontSize: fontSize + "pt",
        height: "fit-content",
        marginLeft: enableOffset ? `${verticalOffset}px` : "auto",
        marginRight: !enableOffset && "auto",
        marginTop: enableOffset ? `${horizontalOffset}px` : "0",
        fontFamily:
          fontType === FONT_TYPES.PREDEFINED || !fontFileUrl
            ? fontFamily
            : "customFontFamily",
      }}
      className="btn btn-rounded"
    >
      {customLabel ? customLabel : buttonText}
    </div>
  )
}

const logoRenderer = (section, isBottomLogo = false, logoMargin) => {
  return (
    <img
      src={getImage(section.logoImage)}
      alt="logo"
      align="center"
      style={{
        marginLeft: "auto",
        marginRight: "auto",
        width: getLogoWidth(section),
        height: "fit-content",
        marginTop: (logoMargin || 0) + "px",
        alignSelf: isBottomLogo ? "flex-end" : "auto",
      }}
    />
  )
}

const signUpRenderer = (linkExplore, button) => {
  return (
    <div className="full-width text-center">
      {buttonRenderer(
        true,
        null,
        button.fontType,
        button.font,
        button.fontFile,
        button.fontSize,
        button.buttonColor,
        button.fontColor,
        button.verticalOffset,
        button.horizontalOffset,
        button.buttonText || "Sign Up"
      )}
      <div
        className="m-2"
        style={{ color: getFontColor(linkExplore?.linkColor) }}
      >
        <p style={{ fontSize: "18px", paddingTop: "10px" }}>
          Already have an account? <b>LOG IN</b>
        </p>
      </div>
    </div>
  )
}

const LogoRenderer = ({
  section,
  isBottomLogo = false,
  containerHeight = 812,
}) => {
  const [imgHeight, setImgHeight] = useState(0)

  const handleSize = img => {
    setImgHeight(img?.target?.offsetHeight)
  }

  const calculateMargin = () => {
    return (section.logoPlacement * (containerHeight - imgHeight)) / 100
  }

  return (
    <img
      onLoad={handleSize}
      src={getImage(section.logoImage)}
      alt="logo"
      align="center"
      style={{
        marginLeft: "auto",
        marginRight: "auto",
        width: getLogoWidth(section),
        height: "fit-content",
        marginTop: `${calculateMargin()}px`,
        alignSelf: isBottomLogo ? "flex-end" : "auto",
      }}
    />
  )
}

export const WelcomeScreenPreview = ({
  logo,
  background,
  bottomLogo,
  linkExplore,
  button,
  scale = "0.35",
  logoMargin,
}) => {
  return (
    <MobileScreen
      itemId="welcome"
      key="welcome"
      backgroundColor={background.bgColor}
      backgroundImage={getImage(background.bgImage)}
      scale={scale}
    >
      {getImage(logo.logoImage) && logoRenderer(logo, false, logoMargin)}
      {signUpRenderer(linkExplore, button)}
      {bottomLogo.isLogoEnabled &&
        getImage(bottomLogo.logoImage) &&
        logoRenderer(bottomLogo, true)}
    </MobileScreen>
  )
}

export const SignUpScreenPreview = ({
  background,
  logo,
  button,
  bottomLogo,
  linkExplore,
  scale = "0.35",
  logoMargin,
}) => {
  return (
    <MobileScreen
      itemId="sign-up"
      key="sign-up"
      backgroundColor={background.bgColor}
      backgroundImage={getImage(background.bgImage)}
      scale={scale}
    >
      {getImage(logo.logoImage) && logoRenderer(logo, false, logoMargin)}
      <div className="width-80 mx-auto text-center">
        <h3
          style={{
            color: getFontColor(linkExplore?.linkColor),
            fontFamily: linkExplore?.font,
            fontSize: `${linkExplore?.fontSize}px`,
          }}
        >
          Sign Up
        </h3>
        <Input
          autoComplete="off"
          className="rounded-3 my-3 mock-input"
          readOnly
          type="text"
          placeholder="Full Name"
        />
        <Input
          autoComplete="off"
          className="rounded-3 my-3 mock-input"
          readOnly
          type="text"
          placeholder="Email"
        />
        <Input
          autoComplete="off"
          className="rounded-3 my-3 mock-input"
          readOnly
          type="text"
          placeholder="Create Password"
        />
        <Input
          autoComplete="off"
          className="rounded-3 my-3 mock-input"
          readOnly
          type="text"
          placeholder="Repeat Password"
        />
        <div className="full-width my-1 legal-box">
          <div
            className="mb-2"
            style={{ color: getFontColor(linkExplore?.linkColor) }}
          >
            By creating an account you agree to our Terms/Privacy
          </div>
          {buttonRenderer(
            true,
            "Submit",
            button.fontType,
            button.font,
            button.fontFile,
            button.fontSize,
            button.buttonColor,
            button.fontColor,
            button.verticalOffset,
            button.horizontalOffset,
            button.buttonText
          )}
        </div>
      </div>
      {bottomLogo.isLogoEnabled &&
        getImage(bottomLogo.logoImage) &&
        logoRenderer(bottomLogo, true)}
    </MobileScreen>
  )
}

export const LoginScreenPreview = ({
  background,
  logo,
  button,
  bottomLogo,
  linkExplore,
  scale = "0.35",
  logoMargin,
}) => {
  return (
    <div>
      <MobileScreen
        itemId="login"
        key="login"
        backgroundColor={background.bgColor}
        backgroundImage={getImage(background.bgImage)}
        scale={scale}
      >
        {getImage(logo.logoImage) && logoRenderer(logo, false, logoMargin)}
        <div className="width-80 mx-auto text-center">
          <h3
            style={{
              color: getFontColor(linkExplore?.linkColor),
              fontFamily: linkExplore?.font,
              fontSize: `${linkExplore?.fontSize}px`,
            }}
          >
            Log In
          </h3>
          <Input
            autoComplete="off"
            className="rounded-3 my-3 mock-input"
            readOnly
            type="text"
            placeholder="Email"
          />
          <Input
            autoComplete="off"
            className="rounded-3 my-3 mock-input"
            readOnly
            type="text"
            placeholder="Password"
          />
          <div
            className="full-width text-end mb-4"
            style={{ color: getFontColor(linkExplore?.linkColor) }}
          >
            Forgot password?
          </div>
          {buttonRenderer(
            true,
            "Submit",
            button.fontType,
            button.font,
            button.fontFile,
            button.fontSize,
            button.buttonColor,
            button.fontColor,
            button.verticalOffset,
            button.horizontalOffset,
            button.buttonText
          )}
        </div>
        {bottomLogo.isLogoEnabled &&
          getImage(bottomLogo.logoImage) &&
          logoRenderer(bottomLogo, true)}
      </MobileScreen>
    </div>
  )
}

export const ResetPasswordScreenPreview = ({
  background,
  logo,
  button,
  bottomLogo,
  scale = "0.35",
  linkExplore,
  logoMargin,
}) => {
  return (
    <MobileScreen
      itemId="reset-password"
      key="reset-password"
      backgroundColor={background.bgColor}
      backgroundImage={getImage(background.bgImage)}
      scale={scale}
    >
      {getImage(logo.logoImage) && logoRenderer(logo, false, logoMargin)}
      <div className="width-80 mx-auto text-center">
        <h3
          style={{
            color: getFontColor(linkExplore?.linkColor),
            fontFamily: linkExplore?.font,
            fontSize: `${linkExplore?.fontSize}px`,
          }}
        >
          Reset password
        </h3>
        <Input
          autoComplete="off"
          className="rounded-3 my-3 mock-input"
          readOnly
          type="text"
          placeholder="Email"
        />
        {buttonRenderer(
          true,
          "Submit",
          button.fontType,
          button.font,
          button.fontFile,
          button.fontSize,
          button.buttonColor,
          button.fontColor,
          button.verticalOffset,
          button.horizontalOffset,
          button.buttonText
        )}
      </div>
      {bottomLogo.isLogoEnabled &&
        getImage(bottomLogo.logoImage) &&
        logoRenderer(bottomLogo, true)}
    </MobileScreen>
  )
}

export const LoadingScreeenPreview = ({
  loadingScreen,
  scale = "0.35",
  logoMargin,
}) => {
  return (
    <MobileScreen
      itemId="loading-screen"
      key="loading-screen"
      backgroundColor={loadingScreen?.background?.bgColor}
      backgroundImage={getImage(loadingScreen?.background?.bgImage)}
      scale={scale}
    >
      {getImage(loadingScreen?.logo?.logoImage) &&
        logoRenderer(loadingScreen?.logo, false, logoMargin)}
    </MobileScreen>
  )
}
